document.addEventListener('DOMContentLoaded', () => {
    const tracks = document.querySelectorAll('.lpcb-achievement-scroll-track');
  
    tracks.forEach(track => {
        const list = track.querySelector('.lpcb-achievement-list');
        if (!list) return;
  
        // すでに複製済みならスキップ
        if (track.querySelectorAll('.lpcb-achievement-list').length > 1) return;
  
        const clone = list.cloneNode(true);
        track.appendChild(clone);

        const isReverse = list.classList.contains('is-scrolling-reverse');

        clone.classList.remove('is-scrolling', 'is-scrolling-reverse');
        list.classList.remove('is-scrolling', 'is-scrolling-reverse');

        void clone.offsetHeight;
        void list.offsetHeight;

        // クラス再適用
        if (isReverse) {
            list.classList.add('is-scrolling-reverse');
            clone.classList.add('is-scrolling-reverse');
        } else {
            list.classList.add('is-scrolling');
            clone.classList.add('is-scrolling');
        }
        // レンダリング完了前に動くとスクロール表示が崩れるので遅延させる
        setTimeout(() => {
          clone.style.animationPlayState = 'running';
          list.style.animationPlayState = 'running';
        }, 3000);
    });
});